var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 22V20H6.5V15.5H11V11H15.5V6.5H20V3H22V8.5H17.5V13H13V17.5H8.5V22H3Z",
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/floorIcon.830c1623a7f222b1863da770832b1a35.svg";
export { ForwardRef as ReactComponent };